import React from 'react'
import { CallUs } from '../callUs'
import PropTypes from 'prop-types'

import styles from './inquiryHeader.module.scss'

const InquiryHeader = ({ className = '', ...rest }) => {
  return (
    <section className={`${styles.inquiryHeader} ${className}`} {...rest}>
      <div className={styles.inquiryHeader__callUs}>
        <CallUs />
      </div>
      <div className={styles.inquiryHeader__separator}>
        <span>or</span>
      </div>
      <p className={styles.inquiryHeader__quote}>Get a Free Flight Quote</p>
    </section>
  )
}

InquiryHeader.propTypes = {
  className: PropTypes.string,
}

export { InquiryHeader }
